import { useEffect } from 'react';

/**
 * 모달 등 오버레이가 열릴 때 문서(body) 세로 스크롤을 막습니다.
 * 여러 컴포넌트에서 동시에 쓸 때를 대비해 잠금 횟수를 refcount 합니다.
 */
let bodyScrollLockCount = 0;
let savedOverflow = '';
let savedPaddingRight = '';

function applyBodyLock() {
    if (bodyScrollLockCount === 0) {
        savedOverflow = document.body.style.overflow;
        savedPaddingRight = document.body.style.paddingRight;
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (sbw > 0) {
            document.body.style.paddingRight = `${sbw}px`;
        }
    }
    bodyScrollLockCount += 1;
}

function releaseBodyLock() {
    bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1);
    if (bodyScrollLockCount === 0) {
        document.body.style.overflow = savedOverflow;
        document.body.style.paddingRight = savedPaddingRight;
        savedOverflow = '';
        savedPaddingRight = '';
    }
}

/**
 * @param {boolean} locked - true일 때 스크롤 잠금
 */
export function useBodyScrollLock(locked) {
    useEffect(() => {
        if (!locked) return undefined;
        applyBodyLock();
        return () => {
            releaseBodyLock();
        };
    }, [locked]);
}
